export default {
    data () {
        return {
            mutableInspectors: [],
            selectedAsset: null,
        };
    },

    methods: {
        fetchInspectors: _.debounce(function (value) {
            if (!this.selectedAsset) {
                toastr.error("Select an asset to continue.");
                return;
            }

            // Handle edge case: asset view response returns data.portfolio.id, inspection view response returns data.portfolio_id
            const portfolioId = this.selectedAsset?.portfolio?.id ?? this.selectedAsset?.portfolio_id;

            axios.get("/users", {
                "params": {
                    page: 1,
                    per_page: 100,
                    search_text: value,
                    status: "active",
                    portfolioId: portfolioId
                }
            })
            .then(response => {
                this.mutableInspectors = response.data?.data ?
                    response.data.data.map(inspector => {
                        if (this.selectedInspector?.id === inspector.id) {
                            this.$set(this.selectedInspector, "user_portfolio_access", inspector.user_portfolio_access);
                        }

                        return inspector;
                    })
                    .sort((a, b) => {
                        return b.user_portfolio_access - a.user_portfolio_access;
                    }) : [];
            }).catch(errors => {
                toastr.error(errors.message);
            });
        }, 300),
    },
};